export const CHAT_PUSH_EVENT = "chat-push-received";

const CHAT_TYPES = new Set(["order_chat", "direct_chat", "restaurant_chat", "taste_try"]);
const recentAlerts = new Map();

export function isChatNotification(payload) {
  return CHAT_TYPES.has(String(payload?.type || ""));
}

function alertKey(payload) {
  return [
    payload?.type || "",
    payload?.conversationId || "",
    payload?.orderId || "",
    payload?.body || "",
    payload?.title || "",
  ].join(":");
}

/** Short tone so a focused tab still makes a sound. Browsers often mute the system banner then. */
export function playChatSound() {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return;
  const ctx = playChatSound.ctx || new Ctx();
  playChatSound.ctx = ctx;
  const tone = () => {
    const start = ctx.currentTime;
    [880, 1175].forEach((frequency, index) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = frequency;
      osc.connect(gain);
      gain.connect(ctx.destination);
      const at = start + index * 0.12;
      gain.gain.setValueAtTime(0.0001, at);
      gain.gain.exponentialRampToValueAtTime(0.18, at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.16);
      osc.start(at);
      osc.stop(at + 0.17);
    });
  };
  if (ctx.state === "suspended") {
    ctx.resume().then(tone).catch(() => {});
    return;
  }
  tone();
}

/** One alert per message even if the page and the service worker both report it. */
export function handleIncomingChatPush(payload) {
  if (!isChatNotification(payload) || typeof window === "undefined") return false;
  const key = alertKey(payload);
  const now = Date.now();
  const last = recentAlerts.get(key) || 0;
  if (now - last < 2000) return false;
  recentAlerts.set(key, now);
  if (typeof document !== "undefined" && document.hasFocus()) {
    // The service worker already shows the system banner. Play a tone because
    // that banner is often silent while this tab is focused.
    playChatSound();
  }
  window.dispatchEvent(new CustomEvent(CHAT_PUSH_EVENT, { detail: payload }));
  return true;
}
